'use client'

import { createContext } from 'react'

/** PC 좌측 보조 레일(#deskrail) — 채팅 화면만 쓴다 (레퍼런스 RAIL_ROUTES = { chat }) */
export const RailSlotContext = createContext<HTMLElement | null>(null)
